export const LISTING_EMAIL_VERIFICATION_REQUIRED_CODE =
  'listing-email-verification-required';

export const LISTING_EMAIL_VERIFICATION_REQUIRED_MESSAGE =
  'Please verify your email address before listing an item. Check your inbox for the verification email, or resend it below.';

export const isUserEmailVerifiedForListing = currentUser =>
  currentUser?.attributes?.emailVerified === true;

export const isListingEmailVerificationRequired = currentUser =>
  Boolean(currentUser?.id) && !isUserEmailVerifiedForListing(currentUser);

export const canCreateListing = currentUser =>
  Boolean(currentUser?.id) && isUserEmailVerifiedForListing(currentUser);

export const createListingEmailVerificationRequiredError = () => ({
  name: 'ListingEmailVerificationRequiredError',
  code: LISTING_EMAIL_VERIFICATION_REQUIRED_CODE,
  status: 403,
  message: LISTING_EMAIL_VERIFICATION_REQUIRED_MESSAGE,
});

export const isListingEmailVerificationRequiredError = error =>
  error?.code === LISTING_EMAIL_VERIFICATION_REQUIRED_CODE ||
  error?.name === 'ListingEmailVerificationRequiredError';
